import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isTime, formatTime, removeCommas, convertAutomatically, sanitizeInputValue } from './utilities';

class TimeInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayValue: formatTime(props.value),
      internalValue: props.value,
      isTyping: false,
    };

    this.debounceTimeout = null;
    this.isComposing = false;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.value !== prevState.internalValue && !prevState.isTyping) {
      return {
        displayValue: formatTime(nextProps.value),
        internalValue: nextProps.value,
      };
    }

    return null;
  }

  componentWillUnmount() {
    clearTimeout(this.debounceTimeout);
  }

  handleCompositionStart = () => {
    // #2250: IME(全角)入力を許容する。変換中はそのまま表示し、確定(compositionend)で
    // 半角へ自動変換 + 不許可文字を削除する。警告トーストは出さない。
    this.isComposing = true;
  };

  handleCompositionEnd = (event) => {
    this.isComposing = false;
    this.handleInputChange(event);
  };

  handleInputChange = (event) => {
    // Skip full-width to half-width conversion while the IME is composing.
    // Writing the converted value back into the controlled input mid-composition
    // makes the IME re-insert its buffer and duplicates the characters.
    // The conversion runs once on compositionend instead.
    if (this.isComposing) {
      clearTimeout(this.debounceTimeout);
      this.setState({ displayValue: event.target.value, isTyping: true });

      this.debounceTimeout = setTimeout(() => {
        this.setState({ isTyping: false });
      }, 500);

      return;
    }

    // #2250: 全角→半角へ変換し、時間欄の許可文字 (数字/ : / 演算子) 以外を削除する。
    // これにより全角や不許可記号を入力しても半角の許容文字だけが残る。
    let value = convertAutomatically(removeCommas(event.target.value), this.props.inputType);
    value = sanitizeInputValue(value, true);

    clearTimeout(this.debounceTimeout);
    this.setState({ displayValue: value, isTyping: true });

    if (isTime(value)) {
      this.setState({ internalValue: value }, () => {
        this.props.onChange(event);
      });
    }

    this.debounceTimeout = setTimeout(() => {
      this.setState({ isTyping: false });
    }, 500);
  };

  handleBlur = (event) => {
    const value = this.state.internalValue || this.props.value;

    this.setState({ displayValue: formatTime(value) }, () => {
      this.props.onChange(event);
    });
  };

  render() {
    // onImeWarning は内部用コールバックなので DOM input へは渡さない。
    const { onImeWarning, ...inputProps } = this.props;

    return (
      <input
        {...inputProps}
        onBlur={this.handleBlur}
        onChange={this.handleInputChange}
        onCompositionEnd={this.handleCompositionEnd}
        onCompositionStart={this.handleCompositionStart}
        placeholder="HH:MM"
        value={this.state.displayValue}
      />
    );
  }
}

TimeInput.propTypes = {
  inputType: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onImeWarning: PropTypes.func,
};

export default TimeInput;
